module.exports = __webpack_public_path__ + "img/IMG_2629_P_L.38b4c1af.webp";